import { EDUCATOR_SERVICE, EDUCATOR_TYPES } from "utils/constants/educator";

export const getEducatorService = (serviceNo: number | null) => {
  if (!serviceNo) return null;
  const service = EDUCATOR_SERVICE.find((x) => x.value === serviceNo);

  return service ? service.label : null;
};

export const getEducatorType = (typeId: number | null) => {
  if (!typeId) return null;
  const typeItem = EDUCATOR_TYPES.find((type) => type.value === typeId);

  return typeItem ? typeItem.label : null;
};
